// To be shown when the user submits the last answer
export const OUTRO_PAGE = "OUTRO";
// To be shown on start
export const LANDING_PAGE = "INTRO";
// To be shown when the survey has been expired
export const CLOSED_PAGE = "CLOSED";
